import styled from 'styled-components';

const TableStyles = styled.div`
  .ant-table-row-expand-icon {
    display: none;
  }

  .children-item {
    display: flex;
    align-items: center;
    &__gender {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      margin-right: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
    }
  }
`;

export default TableStyles;
